<template>

    <div class="row" id="share-opinions" v-click-outside="toggle">
        <div class="col-lg-6"  v-bind:class="[util.form.answer ? 'util-form' : 'util']">
            <div class=""  v-if="!util.form.answer">

                <p class="mb-2">¿Te ha parecido útil/suficiente la información sobre esta variedad?</p>

                <div class="bp-form-group" style="margin-bottom: 0.35rem !important">
                    <div class="content-group">
                        <div class="type-client-selection">
                            <div>
                                <div class="radio-input-block">
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" id="metodoEnvio_13_1" v-model="util.form.answer" name="metodoEnvio_13" value="si">
                                                <label for="metodoEnvio_13_1" class="text">
                                                    <span>Sí</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="radio-input-item">
                                                <input type="radio" tabindex="0" id="metodoEnvio_13_2" v-model="util.form.answer" name="metodoEnvio_13" value="no">
                                                <label for="metodoEnvio_13_2" class="text">
                                                    <span>No</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <small>Para más información consulta nuestra <a target="_blank" href="#">política de privacidad</a> y tratamiento de datos</small>
                </div>
            </div>
            <div v-else-if="!util.form.submited">
                <p class="" style="margin-bottom: 0">{{ this.answerIsTrue ?  "¡Nos alegramos de haberte ayudado!" : "¡Vaya, lamentamos no haberte ayudado!" }}</p>
                <p class="mb-2"> {{ this.answerIsTrue ? "Aun así, si tiene alguna duda, rellene el siguiente formulario y en breve nos pondremos en contacto con usted." : "Si tiene alguna duda, rellene el siguiente formulario y en breve nos pondremos en contacto con usted." }}</p>

                <form action="" @submit.prevent="submitForm('util')">

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="name" type="text" class="form-element" v-model="util.form.nombre" name="name" placeholder="Nombre" value="" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="email" type="email" class="form-element" v-model="util.form.email" name="name" placeholder="Correo electrónico" value="" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="bp-form-group">
                                <textarea placeholder="Mensaje" name="message" v-model="util.form.mensaje" id="" rows="3" style="width: 100%" required></textarea>
                            </div>
                        </div>

                        <div class="col-12 mt-4">
                            <small>Al enviar el formulario, aceptas los <a target="_blank" style="color: black" href="#">términos y condiciones</a> y la <a target="_blank" style="color: black" href="#">política de privacidad</a>.</small>
                        </div>
                        <div class="col-12">
                            <button class="btn btn-outline-dark btn-share-info px-5" style="border-width: 0.15em">
                               Enviar
                            </button>
                        </div>
                    </div>

                </form>

            </div>
            <div v-else>
                <h5 style="font-weight: 700; color: #666666">Recibido, ¡Gracias!</h5>
                <p style="font-weight: bold; font-size: 1.125rem; ">Con tu opinión mejoraremos tu experiencia de compra</p>
            </div>

        </div>
        <div class="col-lg-6" v-bind:class="[information.showForm ? 'information-form' : 'information']">
            <div v-if="!information.showForm">
                <p class="mb-2">Si quieres compartir información o una fotografía de esta variedad sobre la que te siente orgulloso. Envíanosla y la compartiremos.</p>
                <div class="mb-5 mb-md-4 mb-sm-4 mb-4">
                    <button class="btn btn-outline-dark btn-share-info" @click="activateShareInfoForm">
                        Compartir información <i class="fas fa-long-arrow-alt-right"></i>
                    </button>
                </div>
                <div class="mt-3">
                    <small>Para más información consulta nuestra <a target="_blank" href="#">política de privacidad</a> y tratamiento de datos</small>
                </div>
            </div>
            <div v-else-if="!information.form.submited">
                <p class="" style="margin-bottom: 0">¡Gracias por contribuir con tu aportación!</p>
                <p class="mb-2">La información será autentificada por el equipo técnico de Babyplant antes de ser publicada.</p>

                <form action="" @submit.prevent="submitForm('information')">

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="name" type="text" class="form-element" v-model="information.form.nombre" name="name" placeholder="Nombre" value="" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="bp-form-group">
                                <div class="content-group">
                                    <div>
                                        <div class="content-input">
                                            <input id="email" type="email" class="form-element" v-model="information.form.email" name="name" placeholder="Correo electrónico" value="" required>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="bp-form-group">
                                <textarea placeholder="Mensaje" name="message"  rows="3" v-model="information.form.mensaje" style="width: 100%" required></textarea>
                            </div>
                        </div>

                        <div class="col-12 mb-1">
                            <b-form-file
                                accept="image/jpeg, image/png"
                                v-model="information.form.imagen"
                                placeholder="Elige una imagen o arrástrala aquí.."
                                drop-placeholder="Arrastra la imagen aquí..."
                                data-browse="Elegir"
                                browse-text="Buscar"
                            ></b-form-file>
<!--                            <div class="custom-file">-->
<!--                                <input type="file" name="imagen" class="custom-file-input" id="imagen">-->
<!--                                <label class="custom-file-label" for="imagen" data-browse="Elegir" style="border-radius: 0 !important;">Insertar imagen</label>-->
<!--                            </div>-->
                        </div>

                        <div class="col-12 mt-4">
                            <small>Al enviar el formulario, aceptas los <a target="_blank" style="color: black" href="#">términos y condiciones</a> y la <a target="_blank" style="color: black" href="#">política de privacidad</a>.</small>
                        </div>

                        <div class="col-12">
                            <button class="btn btn-outline-dark btn-share-info px-5" style="border-width: 0.15em">
                                Enviar
                            </button>
                        </div>
                    </div>

                </form>
            </div>
            <div v-else>
                <h5 style="font-weight: 700; color: #666666">Recibido, ¡Gracias!</h5>
                <p style="font-weight: bold; font-size: 1.125rem; ">Con tu opinión mejoraremos tu experiencia de compra</p>
            </div>

        </div>
    </div>


</template>

<script>
    export default {
        name: "ShareOpinionsComponent",
        props: ["id","producto"],
        data: function(){
            return {
                // whichShow: null,
                util: {
                    form: {
                        nombre: null,
                        email: null,
                        mensaje: null,
                        respuesta: null,
                        producto: null,
                        articulo_id: null,
                        type: 'informacion_util',
                        sending: false,
                        submited: false,
                    }
                },
                information: {
                    showForm: false,
                    form: {
                        nombre: null,
                        email: null,
                        mensaje: null,
                        producto: null,
                        articulo_id: null,
                        type: 'informacion_adicional',
                        sending: false,
                        submited: false,
                        imagen: null,
                    }
                }

            }
        },
        methods: {
            toggle: function(){
                this.information.showForm = false;
                this.util.form.answer = null;
            },
            activateShareInfoForm: function () {
                this.util.form.answer = null;
                this.information.showForm = true;
            },
            submitForm: function(type){

                if(type === "information"){

                    var formData = new FormData();
                    if (this.information.form.imagen) {
                        formData.append("imagen", this.information.form.imagen);
                    }
                    formData.append("nombre", this.information.form.nombre);
                    formData.append("mensaje", this.information.form.mensaje);
                    formData.append("email", this.information.form.email);
                    formData.append("type", this.information.form.type);
                    formData.append("articulo_id", this.id);
                    formData.append("producto", this.producto);


                    axios.post(this.route('products.information.data'), formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(response => {
                        this.information.form.submited = true;
                    }).catch(e => {
                        this.$toasted.error("Error al enviar el formulario, inténtalo más tarde",3000);
                    });

                }else{
                    this.util.form.articulo_id=this.id;
                    this.util.form.producto=this.producto;

                    axios.post(this.route('products.util.data'), this.util.form).then(response => {
                        this.util.form.submited = true;
                    }).catch(e => {
                        this.$toasted.error("Error al enviar el formulario, inténtalo más tarde");
                    });
                }
            }
        },
        watch: {
            changeAnswer(){
                if(this.util.form.answer != null){
                    this.information.showForm = false;
                }
            }
        },
        computed: {
            changeAnswer(){
                return this.util.form.answer;
            },
            answerIsTrue: function(){
                return this.util.form.answer === "si";
            }
        }
    }
</script>

<style scoped>

    .custom-file-input ~ .custom-file-label[data-browse]::after {
        content: 'Elegir';
    }
</style>
